import { createSlice } from '@reduxjs/toolkit';

const getInitialNotifications = () => {
  try {
    const item = window.localStorage.getItem('notificationsStorage');
    return item ? JSON.parse(item) : [];
  } catch (error) {
    return [];
  }
};

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: {
    notificationsList: getInitialNotifications(),
  },
  reducers: {
    setNotificationsList: (state, { payload }) => {
      /* eslint-disable-line */
      state.notificationsList = payload;
      window.localStorage.setItem('notificationsStorage', JSON.stringify(payload));
    },
  },
});

// Action creators are generated for each case reducer function
export const { setNotificationsList } = notificationsSlice.actions;
